import {CloseDirection, BaseComparator, Result, ResultState} from './BaseComparator';

abstract class SimpleNumberComparator implements BaseComparator<number> {
    protected constructor(private closeThreshold: number) {

    }

    compare(guess: number, actual: number): Result {
        if (guess === actual) {
            return {state: ResultState.MATCH};
        } else {
            const state = Math.abs(guess - actual) <= this.closeThreshold ? ResultState.CLOSE : ResultState.FAR;
            const direction = guess > actual ? CloseDirection.DOWN : CloseDirection.UP;
            return {state: state, direction: direction};
        }
    }
}

export {SimpleNumberComparator};
